<template>
  <v-card-text>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
          <v-text-field name="email" :loading="loading" :append-icon="checkMailValue.status === null ? '' : (checkMailValue.status ? 'check' : 'close')" @change="checkMail()" :hint="!checkMailValue.status ? checkMailValue.message : ''" persistent-hint label="Mail" id="email" v-model="email" type="email" outlined dense></v-text-field>
        </v-col>
        <v-col cols="12" sm="10" offset-sm="1">
          <v-text-field name="password" label="Passwort" hint="Das Passwort muss mindestens 6 Zeichen lang sein." id="password" v-model="password" type="password" outlined dense></v-text-field>
        </v-col>
        <v-col cols="12" sm="10" offset-sm="1">
          <v-text-field name="confirmPassword" label="Passwort bestätigen" id="confirmPassword" v-model="confirmPassword" type="password" :rules="[comparePasswords]" outlined dense></v-text-field>
        </v-col>
        <v-col cols="12" class="mt-2" sm="10" offset-sm="1">
          <v-btn block @click="onSignup()" class="primary" :disabled="!this.password || (this.comparePasswords === 'Passwörter stimmen nicht überein') || this.comparePasswords || (this.checkMailValue.status === false) || (this.checkMailValue.status === null)" :loading="loadingBtn">
            Registrieren
          </v-btn>
        </v-col>
        <v-col cols="12" class="mt-2" sm="10" offset-sm="1">
          <v-btn @click="onDismissed()" block class="caption" text to="/anmelden">
            Anmelden
          </v-btn>
        </v-col>
        <v-col cols="12" class="mt-2" sm="10" offset-sm="1" v-if="errorMessage">   
          <v-alert dismissible v-if="errorMessage.code === 'keinBbr'" class="warning" @dismissed="onDismissed">
            Die Mailadresse gehört zu keinem Bundesbruder. Bitte kontrollier die eingegebene Adresse oder kontaktiere den Schriftführer.
          </v-alert>
          <v-alert dismissible v-if="errorMessage.code === 'auth/email-already-in-use'" class="warning" @dismissed="onDismissed">
            Es existiert bereits ein Account mit dieser E-Mailadresse. Bitte melde dich an oder setze dein Passwort zurück.
          </v-alert>
          <v-alert dismissible v-if="errorMessage.code === 'auth/weak_password'" class="warning" @dismissed="onDismissed">
            Das Passwort muss mindestens 6 Zeichen lang sein.
          </v-alert>
          <v-alert dismissible v-if="(errorMessage.code !== 'keinBbr') && (errorMessage.code !== 'auth/email-already-in-use') && (errorMessage.code !== 'auth/weak_password')" class="warning" @dismissed="onDismissed">
            Bei der Registrierung ist ein Fehler aufgetreten. Fehlercode: {{ errorMessage.code }} | {{ errorMessage.message }}
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </v-card-text>
</template>

<script>
  export default {
    data () {
      return {
        loading: false,
        loadingBtn: false,
        email: '',
        password: '',
        confirmPassword: '',
        checkMailValue: { status: null },
        error: {},
        mailVorhanden: false
      }
    },
    computed: {
      comparePasswords () {
        return this.password !== this.confirmPassword ? 'Passwörter stimmen nicht überein' : ''
      },
      user () {
        return this.$store.state.user.user
      },
      errorMessage () {
        return this.$store.state.user.error
      }
    },
    watch: {
      user (value) {
        if (this.$firebase.auth().currentUser) {
          this.$router.push('/verifizieremail')
        }
      }
    },
    methods: {
      checkMail () {
        this.loading = true
        this.checkMailValue = { status: null }
        var functions = this.$firebase.functions()
        if (this.email) {
          functions.httpsCallable('existMail')({ email: this.email.toLowerCase(), sub: this.$vars.verbindung })
            .then(({ data }) => {
              this.checkMailValue = data
              this.loading = false
            })
            .catch(error => {
              this.error = error
              this.loading = false
            })
        } else {
          this.checkMailValue = { status: null }
          this.loading = false
        }
      },
      onSignup () {
        this.loadingBtn = true
        this.$store.dispatch('user/signUserUp', {email: this.email, password: this.password})
        this.loadingBtn = false
      },
      onDismissed () {
        this.$store.dispatch('clearError')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SignupForm.vue?b7bb93e6